import { render, staticRenderFns } from "./ClockWidget.vue?vue&type=template&id=152b3274&scoped=true"
import script from "./ClockWidget.vue?vue&type=script&lang=js"
export * from "./ClockWidget.vue?vue&type=script&lang=js"
import style0 from "./ClockWidget.vue?vue&type=style&index=0&id=152b3274&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b3274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152b3274')) {
      api.createRecord('152b3274', component.options)
    } else {
      api.reload('152b3274', component.options)
    }
    module.hot.accept("./ClockWidget.vue?vue&type=template&id=152b3274&scoped=true", function () {
      api.rerender('152b3274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/ClockWidget.vue"
export default component.exports